import { render, staticRenderFns } from "./QuotationEdit.vue?vue&type=template&id=667f6012&scoped=true&"
import script from "./QuotationEdit.vue?vue&type=script&lang=js&"
export * from "./QuotationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f6012",
  null
  
)

export default component.exports